export const findInputError = (errors, id) => {
	return Object.keys(errors)
		.filter(key => key.includes(id))
		.reduce((cur, key) => {
			return Object.assign(cur, { error: errors[key] })
		}, {})
}